/** Bottom nav — máximo 5 itens (LUDI_SPEC 5.08) */
export const NAV_ITEMS = [
  { to: '/home', label: 'Início', icon: 'home' },
  { to: '/session', label: 'Sessão', icon: 'session' },
  { to: '/plan', label: 'Plano IA', icon: 'plan' },
  { to: '/history', label: 'Histórico', icon: 'history' },
  { to: '/profile', label: 'Perfil', icon: 'profile' },
];

export const ROUTES_WITHOUT_NAV = ['/session'];
